import React, { useEffect, useState } from "react";

export default function FILTVOfferTimer({ minutes = 180, channelKey }) {
    const [seconds, setSeconds] = useState(minutes * 60);

    // Reset the countdown whenever the offer (or channel) changes.
    useEffect(() => {
        setSeconds(minutes * 60);
    }, [minutes, channelKey]);

    useEffect(() => {
        const timer = setInterval(() => {
            setSeconds((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;

    return (
        <div className="text-[10px] sm:text-xs text-yellow-400 mt-1">
            ⏰ {hrs.toString().padStart(2, "0")}:{mins.toString().padStart(2, "0")}:
            {sec.toString().padStart(2, "0")}
        </div>
    );
}
